import {Component, Prop, Vue} from "vue-property-decorator";
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from "@/mixins/HttpMixin";
import {CampaignItem} from "@/components/communications/CommunicationInterfaces";

@Component({
  components: {
    VueSimpleSpinner,
  },
  mixins: [HttpMixin],
})
export default class CampaignEmailDisplay extends Vue {
  @Prop({type: String, required: true, default: ''})
  messageTypeText!: string;
  @Prop({type: Object, required: true, default: {}})
  selectedCampaign!: CampaignItem;

  email = '';

  get fromUser(): string {
    const appUserId = this.$store.state.user.appUserId;
    const user = this.$store.getters['user/getUser'](appUserId);
    if (!user) {
      return '';
    }
    return user
  }
  async loadFromEmail() {
    let response = await this.httpGet<any>('/current-user', '');
    if (!response || !response.username) {
      throw new Error("Error retrieving username.");
    }
    this.email = response.username;
  }

  async created() {
    await this.loadFromEmail();
  }
}



// WEBPACK FOOTER //
// ./src/components/communications/campaign/CampaignEmailDisplay/CampaignEmailDisplay.ts